// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"f3ef6514","678":"f3ef6514"}[chunkId] + ".chunk.js";
};